import { Chip } from "@mui/material";
import styles from "./TaggedList.module.scss";
import _ from "lodash";
import { Box } from "@mui/system";

const TaggedList = ({ type, data, selectedItem, labelName = "label" }) => {
    return (
        <div style={{ width: "100%", overflow: "hidden" }}>
            {(type === "floorsData" ||
                type === "shiftData" ||
                type === "daysData" ||
                type === "dxData" ||
                type === "doctorData" ||
                type === "hospitalData" ||
                type === "nurseData") &&
                selectedItem.length > 0 && (
                    <Box 
                        sx={{ 
                            width: "100%",
                            maxWidth: "100%",
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "nowrap",
                            overflowX: "auto",
                            overflowY: "hidden",
                            gap: "0px",
                            paddingBottom: "4px",
                            "&::-webkit-scrollbar": {
                                height: "6px",
                            },
                            "&::-webkit-scrollbar-track": {
                                backgroundColor: "#f1f1f1",
                                borderRadius: "3px",
                            },
                            "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "#888",
                                borderRadius: "3px",
                                "&:hover": {
                                    backgroundColor: "#555",
                                },
                            },
                        }}
                    >
                        {data.map((item, index) =>
                            _.includes(selectedItem, item._id) ? (
                                <Chip
                                    key={index}
                                    className={`${styles.taggedList}`}
                                    size="small"
                                    label={item[labelName]}
                                    sx={{ flexShrink: 0, minWidth: "fit-content" }}
                                />
                            ) : null
                        )}
                    </Box>
                )}
        </div>
    );
};

export default TaggedList;
